import React from 'react'

const IntegratedDashboardIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 16.933 16.933"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#ff7f29"
                        d="M6.35 7.28v1.931c0 .088.043.171.117.22l1.853 1.24a.265.265 0 0 0 .293 0l1.853-1.24a.265.265 0 0 0 .118-.22v-1.93H6.35z"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#ff9751"
                        d="M1.323 3.969a.265.265 0 0 0-.264.263v1.854a.265.265 0 0 0 .264.264H3.44a.265.265 0 0 0 .265-.264V4.232a.265.265 0 0 0-.265-.263z"
                        opacity={1}
                        data-original="#ff9751"
                        className=""
                    />
                    <path
                        fill="#e4eff8"
                        d="M2.117 3.969v.793h.53v-.793z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#ff7f29"
                        d="M3.176 3.969v1.588a.265.265 0 0 1-.265.263H1.059v.266a.265.265 0 0 0 .264.264H3.44a.265.265 0 0 0 .265-.264V4.232a.265.265 0 0 0-.265-.263z"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#ff9751"
                        d="M1.322 10.584a.265.265 0 0 0-.264.263v1.854a.265.265 0 0 0 .264.264h2.117a.265.265 0 0 0 .266-.264v-1.854a.265.265 0 0 0-.266-.263z"
                        opacity={1}
                        data-original="#ff9751"
                        className=""
                    />
                    <path
                        fill="#e4eff8"
                        d="M2.117 10.584v.793h.529v-.793z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#ff7f29"
                        d="M3.175 10.584v1.588a.265.265 0 0 1-.265.263H1.058v.266a.265.265 0 0 0 .264.264h2.117a.265.265 0 0 0 .266-.264v-1.854a.265.265 0 0 0-.266-.263z"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#ff9751"
                        d="M7.407 14.023a.265.265 0 0 0-.263.264v1.854a.265.265 0 0 0 .263.263h2.117a.265.265 0 0 0 .266-.263v-1.854a.265.265 0 0 0-.266-.264z"
                        opacity={1}
                        data-original="#ff9751"
                        className=""
                    />
                    <path
                        fill="#e4eff8"
                        d="M8.202 14.023v.793h.53v-.793z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#ff7f29"
                        d="M9.26 14.023v1.588a.265.265 0 0 1-.265.264H7.144v.266a.265.265 0 0 0 .263.263h2.117a.265.265 0 0 0 .266-.263v-1.854a.265.265 0 0 0-.266-.264z"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#ff9751"
                        d="M13.492 10.584a.265.265 0 0 0-.263.263v1.854a.265.265 0 0 0 .263.264h2.117a.265.265 0 0 0 .266-.264v-1.854a.265.265 0 0 0-.266-.263z"
                        opacity={1}
                        data-original="#ff9751"
                        className=""
                    />
                    <path
                        fill="#e4eff8"
                        d="M14.287 10.584v.793h.53v-.793z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#ff7f29"
                        d="M15.346 10.584v1.588a.265.265 0 0 1-.266.263H13.23v.266a.265.265 0 0 0 .263.264h2.117a.265.265 0 0 0 .266-.264v-1.854a.265.265 0 0 0-.266-.263z"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#ff9751"
                        d="M7.407.53a.265.265 0 0 0-.263.263v1.853a.265.265 0 0 0 .263.264h2.117a.265.265 0 0 0 .266-.264V.793a.265.265 0 0 0-.266-.264z"
                        opacity={1}
                        data-original="#ff9751"
                        className=""
                    />
                    <path
                        fill="#e4eff8"
                        d="M8.202.53v.792h.53V.53z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#ff7f29"
                        d="M9.26.53v1.587a.265.265 0 0 1-.265.264H7.144v.265a.265.265 0 0 0 .263.264h2.117a.265.265 0 0 0 .266-.264V.793a.265.265 0 0 0-.266-.264z"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#ff9751"
                        d="M13.492 3.97a.265.265 0 0 0-.264.263v1.854a.265.265 0 0 0 .264.263h2.117a.265.265 0 0 0 .266-.263V4.233a.265.265 0 0 0-.266-.263z"
                        opacity={1}
                        data-original="#ff9751"
                        className=""
                    />
                    <path
                        fill="#e4eff8"
                        d="M14.287 3.97v.793h.53V3.97z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#ff7f29"
                        d="M15.346 3.97v1.588a.265.265 0 0 1-.266.263h-1.852v.266a.265.265 0 0 0 .264.263h2.117a.265.265 0 0 0 .266-.263V4.233a.265.265 0 0 0-.266-.263z"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#ff9751"
                        d="M8.45 5.895a.265.265 0 0 0-.118.037L6.479 7.033a.265.265 0 0 0 0 .456L8.332 8.59c.083.05.186.05.27 0l1.851-1.101a.265.265 0 0 0 0-.456L8.602 5.932a.265.265 0 0 0-.153-.037z"
                        opacity={1}
                        data-original="#ff9751"
                        className=""
                    />
                    <path
                        fill="#e4eff8"
                        d="m7.691 6.313-.508.302 2.18 1.512v.831l.53-.354v-.781z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#c4dcf0"
                        d="M9.364 8.137v.821l.529-.354v-.781z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <g fill="#549ad4">
                        <path
                            d="M12.922 3.578c.261.237.617-.156.355-.393a7.14 7.14 0 0 0-2.611-1.515.293.293 0 0 0-.09-.014c-.303.018-.35.429-.072.518.897.29 1.72.77 2.418 1.404zM6.266 1.67a7.142 7.142 0 0 0-2.61 1.515c-.262.237.094.63.356.393a6.613 6.613 0 0 1 2.416-1.404c.298-.095.215-.53-.093-.516a.253.253 0 0 0-.07.012zM6.36 4.71c-.301.187-.036.631.27.454a3.564 3.564 0 0 1 3.673 0c1.138.68 1.841 1.938 1.841 3.303v.393l-.316-.315a.254.254 0 0 0-.21-.08c-.224.023-.325.296-.163.453l.793.795a.265.265 0 0 0 .375 0l.793-.795c.246-.256-.123-.62-.373-.373l-.37.368v-.446c0-1.547-.797-2.98-2.099-3.756a4.11 4.11 0 0 0-2.107-.584 4.11 4.11 0 0 0-2.108.584zM15.215 6.875a.265.265 0 0 0-.258.32c.082.42.125.845.125 1.272 0 .427-.043.853-.125 1.272-.08.354.46.46.52.1a7.137 7.137 0 0 0 0-2.746.265.265 0 0 0-.262-.218zM1.455 7.097a7.113 7.113 0 0 0 .003 2.745c.07.35.587.24.519-.103a6.608 6.608 0 0 1-.002-2.543.265.265 0 0 0-.264-.319.27.27 0 0 0-.256.22zM4.34 7.219l-.82.793c-.25.258.112.62.369.381l.37-.36v.434c0 1.547.798 2.979 2.1 3.756a4.092 4.092 0 0 0 4.215 0c.298-.177.044-.63-.271-.453-1.138.679-2.534.679-3.672 0S4.789 9.832 4.789 8.467v-.404l.313.324c.255.248.622-.117.38-.37l-.769-.792a.264.264 0 0 0-.215-.08.263.263 0 0 0-.158.074zM10.504 14.76c-.336.11-.172.614.164.504a7.14 7.14 0 0 0 2.61-1.516c.18-.158.072-.457-.183-.463a.27.27 0 0 0-.173.07 6.622 6.622 0 0 1-2.418 1.405zM3.656 13.748a7.144 7.144 0 0 0 2.612 1.516c.336.1.494-.39.162-.504a6.616 6.616 0 0 1-2.418-1.404.256.256 0 0 0-.19-.069c-.238.011-.344.304-.166.461z"
                            fill="#549ad4"
                            opacity={1}
                            data-original="#549ad4"
                            className=""
                        />
                    </g>
                </g>
            </svg>

        </>
    )
}

export default IntegratedDashboardIcon